<template>
  <component
    :is="component"
    :item="props.item"
    :class="bem()"
  />
</template>

<script setup>
import {
  CredibilityReview,
  CredibilityPR,
  CredibilityImage,
  CredibilityImageVideo,
  CredibilitySocial
} from '#components'

const bem = useBEM('CredibilityCard')

const props = defineProps({
  item: { type: Object, required: true }
})

const component = computed(() => {
  switch (props.item.postType) {
    case 'review':
      return CredibilityReview;
    case 'pr':
      return CredibilityPR;
    case 'image':
      return CredibilityImage;
    case 'imagevideo':
      return CredibilityImageVideo;
    case 'social':
      return CredibilitySocial;
    default:
      return 'div';
  }
})
</script>

<style lang="postcss">
.CredibilityCard {
  @apply w-full relative;
}
</style>